/* eslint-disable jsx-a11y/anchor-is-valid */
import cn from 'classnames';
import { Banner, Content } from 'store/landing/types';
import React, { useRef } from 'react';
import Slider from 'react-slick';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './LPCarousel.module.scss';

const PrevArrow = ({ className, onClick }: any) => {
  return (
    <div className={cn(className, styles.arrow)}>
      <div className={styles.arrLeft} onClick={onClick} />
    </div>
  );
};
const NextArrow = ({ className, onClick }: any) => {
  return (
    <div className={cn(className, styles.arrow)}>
      <div className={styles.arrRight} onClick={onClick} />
    </div>
  );
};

const LPCarousel = ({ contentItem }: { contentItem: Content }) => {
  const horizontalSlider = useRef(null);
  const { isDesktopDevice } = useLandingPageContext();

  const onClickImage = (event: React.MouseEvent, banner: Banner) => {
    event.preventDefault();
    const isClickable = !banner.buttonLabel;
    if (isClickable && banner.referenceUrl) {
      window.location.href = banner.referenceUrl;
    }
  };

  return (
    <div
      className={styles.container}
      style={{
        height: `${contentItem.bannerGroup.height}px`,
      }}
    >
      <Slider
        ref={horizontalSlider}
        accessibility={false}
        speed={300}
        dots
        arrows
        fade
        adaptiveHeight={false}
        waitForAnimate={false}
        slidesToShow={1}
        slidesToScroll={1}
        lazyLoad="progressive"
        prevArrow={<PrevArrow />}
        nextArrow={<NextArrow />}
      >
        {contentItem.bannerGroup.banners.map((banner) => (
          <div key={banner.entryId} className={styles.imageContainer}>
            <a onClick={(event: React.MouseEvent) => onClickImage(event, banner)}>
              <img
                src={isDesktopDevice ? banner.bannerImageUrlDesktop : banner.bannerImageUrlMobile}
                alt=""
                style={{
                  height: `${contentItem.bannerGroup.height}px`,
                }}
              />
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default LPCarousel;
